// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"PostAddForm_formWrapper__2udps","headerWrapper":"PostAddForm_headerWrapper__1Dh61"};